import { apiGetSignalsSorted } from "@/Groups/Signals/private/api/signalsApi";

export const getSignalsWithSort = async ({ commit, state }, { key, direction }) => {
  commit("TOGGLE_LOADING_FLAG", true);
  commit("SET_ACTIVE_SORT", { key, direction });

  try {
    const data = await apiGetSignalsSorted(key, direction, null, state.searchQuery);
    commit("CLEAR_DATA");
    commit("SET_DATA", data.results);
    commit("SET_NEW_LINK", data.next || null);
  } catch (err) {
    console.error("Ошибка при получении отсортированных сигналов:", err);
    throw err;
  } finally {
    commit("TOGGLE_LOADING_FLAG", false);
  }
};

export const applySort = async ({ dispatch }, { key, direction }) => {
  await dispatch("getSignalsWithSort", { key, direction });
};

export const resetSort = async ({ dispatch }) => {
  await dispatch("getSignals");
};